export enum DeviceWarningState {
  None = 'None',
  NotAvailable = 'NotAvailable',
  Blocked = 'Blocked',
  InUse = 'InUse',
  Other = 'Other',
}
